export default __webpack_public_path__ + "files/notokr-regular.woff2";